export default __webpack_public_path__ + "static/media/icon3d__communitaction.509eabe5.png";